/* Henna By R — theme scripts. Kept small: no framework, no build step. */
(function () {
  'use strict';

  var root = document.documentElement;

  /* Mobile menu drawer */
  var drawer = document.getElementById('MenuDrawer');
  var openBtn = document.querySelector('[data-menu-open]');

  function setMenu(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) {
      var first = drawer.querySelector('a');
      if (first) first.focus();
    } else if (openBtn) {
      openBtn.focus();
    }
  }

  if (drawer) {
    if (openBtn) openBtn.addEventListener('click', function () { setMenu(true); });
    drawer.querySelectorAll('[data-menu-close]').forEach(function (el) {
      el.addEventListener('click', function () { setMenu(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) setMenu(false);
    });
  }

  /* Announcement bar: rotate messages when there is more than one */
  var announce = document.querySelector('[data-announce]');
  if (announce) {
    var msgs = announce.querySelectorAll('.announce__msg');
    if (msgs.length > 1) {
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, 4500);
    }
  }

  /* Header shadow once the page scrolls */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Reveal on scroll */
  var items = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && items.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  } else {
    items.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Variant select: keep the price in step with the chosen option */
  var select = document.querySelector('[data-variant-select]');
  var priceEl = document.querySelector('[data-price]');
  if (select && priceEl) {
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
    });
  }

  /* Add to bag: stay on the page and show a confirmation */
  var toast = document.querySelector('[data-toast]');
  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(function () { toast.classList.remove('is-visible'); }, 2600);
  }

  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var data = new FormData(form);
      fetch(form.action, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: data
      }).then(function (res) {
        if (!res.ok) throw new Error('Add to bag failed');
        return fetch('/cart.js').then(function (r) { return r.json(); });
      }).then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
        showToast('Added to your bag');
      }).catch(function () {
        form.submit();
      });
    });
  });

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Hero photo drifts slower than the page */
  var parallax = document.querySelectorAll('[data-parallax]');
  if (parallax.length && !reduceMotion) {
    var ticking = false;
    var updateParallax = function () {
      parallax.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * -0.08;
        el.style.setProperty('--py', offset.toFixed(1) + 'px');
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(updateParallax); }
    }, { passive: true });
    updateParallax();
  }

  /* Range story: hovering a product shows its photo */
  var storyImg = document.querySelector('[data-story-img]');
  if (storyImg) {
    var original = storyImg.getAttribute('src');
    var swapTo = function (src) {
      if (!src || storyImg.getAttribute('src') === src) return;
      storyImg.classList.add('is-swapping');
      setTimeout(function () {
        storyImg.setAttribute('src', src);
        storyImg.classList.remove('is-swapping');
      }, 220);
    };
    document.querySelectorAll('[data-story-swap]').forEach(function (item) {
      var pre = new Image();
      pre.src = item.dataset.storySwap;
      item.addEventListener('mouseenter', function () { swapTo(item.dataset.storySwap); });
    });
    var list = document.querySelector('.range-list');
    if (list) list.addEventListener('mouseleave', function () { swapTo(original); });
  }

  /* Tabs (application guides) */
  document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
    var buttons = tabs.querySelectorAll('[role="tab"]');
    buttons.forEach(function (btn, index) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) {
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', String(active));
          if (panel) {
            panel.hidden = !active;
            panel.classList.toggle('is-active', active);
          }
        });
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var next = buttons[(index + (e.key === 'ArrowRight' ? 1 : buttons.length - 1)) % buttons.length];
        next.focus();
        next.click();
      });
    });
  });

  /* Collection filters: apply on change, one panel open at a time */
  document.querySelectorAll('[data-facets]').forEach(function (form) {
    var submit = function () {
      // Leave empty price fields out of the URL
      form.querySelectorAll('input[type="number"]').forEach(function (input) {
        input.disabled = input.value === '';
      });
      var grid = document.querySelector('.collection-page .grid');
      if (grid) grid.classList.add('is-loading');
      form.submit();
    };
    form.querySelectorAll('[data-facet-auto]').forEach(function (el) {
      el.addEventListener('change', submit);
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submit();
    });
    var facets = form.querySelectorAll('[data-facet]');
    facets.forEach(function (facet) {
      facet.addEventListener('toggle', function () {
        if (!facet.open) return;
        facets.forEach(function (other) { if (other !== facet) other.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) facets.forEach(function (f) { f.open = false; });
    });
  });

  /* Lightbox for gallery photos */
  var dialog = document.querySelector('[data-lightbox-dialog]');
  if (dialog && typeof dialog.showModal === 'function') {
    var lbImg = dialog.querySelector('[data-lightbox-img]');
    var lbCount = dialog.querySelector('[data-lightbox-count]');
    var group = [];
    var current = 0;
    var showPhoto = function (i) {
      current = (i + group.length) % group.length;
      var item = group[current];
      lbImg.classList.remove('is-in');
      lbImg.src = item.dataset.full;
      lbImg.alt = item.dataset.alt || '';
      lbCount.textContent = (current + 1) + ' / ' + group.length;
      requestAnimationFrame(function () { lbImg.classList.add('is-in'); });
    };
    document.querySelectorAll('[data-lightbox]').forEach(function (container) {
      var items = Array.prototype.slice.call(container.querySelectorAll('[data-lightbox-item]'));
      items.forEach(function (item, index) {
        item.addEventListener('click', function () {
          group = items;
          showPhoto(index);
          dialog.showModal();
          document.body.style.overflow = 'hidden';
        });
      });
    });
    var close = function () { dialog.close(); };
    dialog.addEventListener('close', function () { document.body.style.overflow = ''; });
    dialog.querySelector('[data-lightbox-close]').addEventListener('click', close);
    dialog.querySelector('[data-lightbox-prev]').addEventListener('click', function () { showPhoto(current - 1); });
    dialog.querySelector('[data-lightbox-next]').addEventListener('click', function () { showPhoto(current + 1); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') showPhoto(current + 1);
      if (e.key === 'ArrowLeft') showPhoto(current - 1);
    });
    var startX = null;
    dialog.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    dialog.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) showPhoto(current + (dx < 0 ? 1 : -1));
      startX = null;
    });
  }

  root.classList.add('js-ready');
})();
